/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import { toast } from 'react-toastify';
// API
import { getTeamFilter, getRepFilter, getGroupFilter } from '../../../api/filterOptionsApi';
// Helper Functions
import {
  filterValue,
  filterTeamOptions,
  filterRepOptions,
  filterGroupOptions,
} from '../../../helpers/filterFunctions';
// Context
import useCallPerformanceContext from '../context/useCallPerformanceContext';

export default function Filter() {
  const { filterForm, setFilterForm, handleGenerateFilter, handleClearFilter } =
    useContext(useCallPerformanceContext);

  const [teamOptions, setTeamOptions] = useState([]);
  const [repOptions, setRepOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);

  const loadTeamDropdown = async () => {
    const request = {
      group: filterValue(filterForm?.group),
      rep_id: filterValue(filterForm?.rep_id),
      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
    };
    const reponse = await getTeamFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterTeamOptions(data);

      setTeamOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadRepDropdown = async () => {
    const request = {
      team: filterValue(filterForm?.team),
      group: filterValue(filterForm?.group),
      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
      is_cpd: true,
    };
    const reponse = await getRepFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);
      setRepOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadGroupaDropdown = async () => {
    const request = {
      rep_id: filterValue(filterForm?.rep_id),
      team: filterValue(filterForm?.team),
      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
    };
    const reponse = await getGroupFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterGroupOptions(data);

      setGroupOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleChangeDate = (value, name) => {
    if (name === 'date_from') {
      setFilterForm({
        ...filterForm,
        date_from: moment(value).format('YYYY-MM-DD'),
        date_to: moment(value).endOf('month').format('YYYY-MM-DD'),
      });
    }

    if (name === 'date_to') {
      if (moment(value).format('M') !== moment(filterForm?.date_from).format('M')) {
        toast.warning('Please select date with same month..');
        return;
      }
      setFilterForm({
        ...filterForm,
        date_to: moment(value).format('YYYY-MM-DD'),
      });
    }
  };
  useEffect(() => {
    loadTeamDropdown();
    loadRepDropdown();
    loadGroupaDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='team'
            disableClearable
            fullWidth
            options={teamOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Team' />}
            size='small'
            value={filterForm?.team}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'team')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='MPR' />}
            size='small'
            value={filterForm?.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='group'
            disableClearable
            fullWidth
            options={groupOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Group' />}
            size='small'
            value={filterForm?.group}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'group')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={1}>
          <DesktopDatePicker
            label='Date From'
            inputFormat='MM/DD/YYYY'
            value={filterForm.date_from}
            onChange={(e) => handleChangeDate(e, 'date_from')}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={1}>
          <DesktopDatePicker
            label='Date From'
            inputFormat='MM/DD/YYYY'
            value={filterForm?.date_to}
            onChange={(e) => handleChangeDate(e, 'date_to')}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateFilter}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleClearFilter()}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
